import { createAssetsHelper } from '@wayfinder/assets-api-contract/client';
import * as Config from '../config';

const getHelper = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken();
    return createAssetsHelper({
        token: accessToken,
        baseUrl: `https://assets-api.locuslabs.com/${stage}`,
    });
};

const Assets = {
    getPublishStatus: async (venueId, opts) => {
        const helper = await getHelper();
        const response = await helper.getStatus(venueId, {
            statusFilter: opts?.statusFilter,
        });
        return response.data;
    },
    publish: async venueId => {
        const helper = await getHelper();
        const response = await helper.publish(venueId);
        return response.data;
    },
    // Global publish freeze. Uses the typed assets-api-contract client. Fails open.
    getPublishFreeze: async (stage = Config.getStage()) => {
        try {
            const helper = await getHelper(stage);
            const response = await helper.getPublishFreeze();
            return { frozen: Boolean(response?.data?.frozen) };
        } catch {
            return { frozen: false };
        }
    },
};

export { Assets };
